/* global */
/*
 * PIX price recalculator.
 *
 * Why: pix-price.liquid renderiza com base em variant.price do Shopify (preço
 * "tabelado"). Mas o tema Altogiro aplica automatic-discount via Storefront API
 * (cartCreate query) que retorna o preço FINAL — esse cálculo só rola
 * client-side, depois do Liquid já ter rasterizado.
 *
 * Sem este helper, produtos com automatic discount mostram PIX calculado
 * sobre o preço errado (ex: R$ 479,90 × 0.95 = R$ 455,90 quando deveria
 * ser R$ 335,93 × 0.95 = R$ 319,13).
 *
 * Uso: window.__pixPrice.updateScope(rootElement, finalPriceInBRL)
 *
 * Chamado por:
 *   - assets/automatic-discount-front.js (applyPriceToCard)
 *   - sections/custom-main-product.liquid (applyMainProductPriceInfo)
 *
 * Markup esperado (gerado por snippets/pix-price.liquid):
 *   <div class="pix-price" data-pix-pct="5" data-pix-base-price="47990">
 *     ...
 *     <strong data-pix-final>R$ 455,90</strong>
 *     ...
 *     <strong data-pix-savings>R$ 24,00</strong>
 *   </div>
 *
 * data-pix-base-price é em CENTAVOS (alinhado com cart.total_price / variant.price em Liquid).
 * finalPriceInBRL passado pelo caller é em REAIS (formato do auto-discount API: 335.93).
 */
(function () {
  if (window.__pixPrice) return;

  function formatBRL(valueInBrl) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(valueInBrl);
  }

  /**
   * Recalcula UM elemento .pix-price com base em um novo preço.
   * @param {HTMLElement} el — elemento .pix-price
   * @param {number} basePriceCents — preço base novo, em centavos (inteiro)
   */
  function recalc(el, basePriceCents) {
    if (!el || !(basePriceCents > 0)) return;

    // DEEP-OPT E.6: skip recalc + DOM write se já foi calculado com mesmo valor.
    // applyPriceToCard() chama updateScope() em CADA card de byVariant[variantId],
    // então PLP com vários cards do mesmo variant disparava recalc redundante.
    var lastCalc = el.getAttribute('data-pix-last-calc');
    if (lastCalc === String(basePriceCents)) return;

    var pct = parseInt(el.getAttribute('data-pix-pct'), 10);
    if (!(pct > 0)) return;

    var remainderPct = 100 - pct;
    // Math.trunc para alinhar com Liquid divided_by (truncação pra baixo)
    var finalCents = Math.trunc((basePriceCents * remainderPct) / 100);
    var savingsCents = basePriceCents - finalCents;

    el.setAttribute('data-pix-base-price', String(basePriceCents));
    el.setAttribute('data-pix-last-calc', String(basePriceCents));

    var finalEl = el.querySelector('[data-pix-final]');
    if (finalEl) finalEl.textContent = formatBRL(finalCents / 100);

    var savingsEl = el.querySelector('[data-pix-savings]');
    if (savingsEl) savingsEl.textContent = formatBRL(savingsCents / 100);
  }

  /**
   * Atualiza todos .pix-price dentro de um escopo (card, productRoot, drawer).
   * @param {HTMLElement|Document} scope
   * @param {number} newBasePriceBrl — preço base novo em REAIS (ex: 335.93)
   */
  function updateScope(scope, newBasePriceBrl) {
    if (!scope || !(newBasePriceBrl > 0)) return;
    var newBaseCents = Math.round(newBasePriceBrl * 100);
    var elements = scope.querySelectorAll('.pix-price');
    if (!elements || !elements.length) return;
    elements.forEach(function (el) {
      recalc(el, newBaseCents);
    });
  }

  window.__pixPrice = {
    updateScope: updateScope,
    recalc: recalc,
    formatBRL: formatBRL
  };
})();
